import { useMemo } from "react"

import { IRecord } from "interfaces"

import { useSponsoredContent } from "./useSponsoredContent"
import { ISponsoredContentResult } from "providers/venue/types"

interface IUseSponsoredHomepageSpotlightResult {
  homepageSpotlightConfig: ISponsoredContentResult
  homepageSpotlights: IRecord[]
}

type UseHomepageSpotlight = () => IUseSponsoredHomepageSpotlightResult

export const useSponsoredHomepageSpotlight: UseHomepageSpotlight = () => {
  const { homepageSpotlight: homepageSpotlightConfig } = useSponsoredContent()

  // Prepare promotion and event list for showing at the carousel
  const homepageSpotlights = useMemo(
    () =>
      homepageSpotlightConfig?.data?.sort(
        (a, b) => (a.properties.order ?? 0) - (b.properties.order ?? 0)
      ) ?? [],
    [homepageSpotlightConfig?.data]
  )

  return {
    homepageSpotlightConfig,
    homepageSpotlights,
  }
}
